import currency from 'currency.js';
export default function formatCurrency(amount, options) {
    return currency(amount, options).format();
}
//# sourceMappingURL=formatCurrency.js.map